export default __webpack_public_path__ + "static/logo-5bcd05cf36d405211ca20c48a56dc404.svg";